import { FC, ReactElement, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAuth, User } from 'firebase/auth';

import { personalDetailsManager } from '@mopla/business-logic';
import { Loader } from '@mopla/ui';

import { WelcomeStep } from '../pages/welcomeV2/constants';

const WelcomeRoute: FC<{ children: ReactElement }> = ({ children }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const [userData, setUserData] = useState<User | null>(null);
	const [loading, setLoading] = useState<boolean>(true);

	const tryOurApp = location.search.includes(WelcomeStep.tryOurApp);
	const shouldVerify = location.search.includes(WelcomeStep.verifyEmail);
	const verifyAndChangeEmail = location.search.includes(
		WelcomeStep.verifyAndChangeEmail
	);
	const personalDetails = personalDetailsManager.get({ safe: true });

	useEffect(() => {
		setLoading(true);
		getAuth().onAuthStateChanged((user) => {
			setUserData(user);
			setLoading(false);
		});
	}, []);

	useEffect(() => {
		if (
			!loading &&
			userData &&
			userData.emailVerified &&
			personalDetails === 'completed' &&
			!shouldVerify &&
			!tryOurApp &&
			!verifyAndChangeEmail
		) {
			console.log('navigate to home');
			navigate('/home', { replace: true });
		}
	}, [
		loading,
		userData,
		navigate,
		personalDetails,
		shouldVerify,
		tryOurApp,
		verifyAndChangeEmail,
	]);

	if (loading) {
		return <Loader delay={100} />;
	}

	return !loading &&
		(!userData ||
			(userData && !userData.emailVerified) ||
			(userData && shouldVerify) ||
			(userData && tryOurApp) ||
			(userData && !personalDetails) ||
			(userData && verifyAndChangeEmail))
		? children
		: null;
};

export default WelcomeRoute;
